import {
    GET_GPS_PLOT_DATA,
    GPS_PLOT_API_SUCCESS,
    GPS_PLOT_API_FAIL,
} from "./actionTypes";

export const getGpsPlotData = (sid) => ({
    type: GET_GPS_PLOT_DATA,
    payload: { sid },
});

export const gpsPlotApiSuccess = (data) => ({
    type: GPS_PLOT_API_SUCCESS,
    payload: data,
});

export const gpsPlotApiFail = (error) => ({
    type: GPS_PLOT_API_FAIL,
    payload: { error },
});
